import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = { class: "home page" };
var _hoisted_2 = { class: "home__header" };
var _hoisted_3 = { class: "home__header-logo" };
var _hoisted_4 = { class: "home__header-search" };
var _hoisted_5 = ["src"];
var _hoisted_6 = { class: "home__ecosystem home__block" };
var _hoisted_7 = { class: "home__ecosystem-header home__block-header" };
var _hoisted_8 = {
    key: 0,
    class: "home__ecosystem-content home__block-content"
};
var _hoisted_9 = { class: "home__events home__block" };
var _hoisted_10 = { class: "home__events-header home__block-header" };
var _hoisted_11 = {
    key: 0,
    class: "home__events-content home__block-content"
};
var _hoisted_12 = { class: "home__services home__block" };
var _hoisted_13 = { class: "home__services-header home__block-header" };
var _hoisted_14 = {
    key: 0,
    class: "home__services-content home__block-content"
};
var _hoisted_15 = { class: "home__news home__block" };
var _hoisted_16 = { class: "home__news-header home__block-header" };
var _hoisted_17 = { class: "home__news-content home__block-content" };
var _hoisted_18 = { class: "home__news-card-title" };
var _hoisted_19 = { class: "news-subtitle" };
var _hoisted_20 = { key: 0 };
var _hoisted_21 = { key: 1 };
var _hoisted_22 = { class: "home__matches home__block" };
var _hoisted_23 = { class: "home__matches-content home__block-content" };
var _hoisted_24 = { class: "home__matches-card" };
var _hoisted_25 = { class: "home__matches-card" };
var _hoisted_26 = { class: "home__partners home__block" };
var _hoisted_27 = { class: "home__partners-header home__block-header" };
var _hoisted_28 = {
    key: 0,
    class: "home__partners-content home__block-content"
};
var _hoisted_29 = { class: "home__materials home__block" };
var _hoisted_30 = { class: "home__materials-content home__block-content" };
var _hoisted_31 = { class: "footer__documents footer__column" };
var _hoisted_32 = ["href"];
var _hoisted_33 = { class: "footer__requisites footer__column" };
var _hoisted_34 = ["href"];
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useBase } from '@/composables/base';
import VariableLogo from '@/components/VariableLogo.vue';
import SuccessfulPayment from '@/components/SuccessfulPayment.vue';
import magnifierIcon from '@/assets/icons/magnifier.svg';
import ServicesSwiper from '@/components/ServicesSwiper.vue';
import PartnerList from '@/components/PartnerList.vue';
import MaterialLinkCard from '@/components/MaterialLinkCard.vue';
import userPlaceholder from '@/assets/icons/user.svg';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeView',
    setup: function (__props) {
        var _this = this;
        var route = useRoute();
        var showNotification = ref(false);
        var getHomeContent = useBase().getHomeContent;
        var localHomeContent = ref();
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (route.query.showNotification === 'true') {
                            showNotification.value = true;
                            localStorage.removeItem('confirmUid');
                            setTimeout(function () {
                                showNotification.value = false;
                            }, 3000);
                        }
                        _a = localHomeContent;
                        return [4 /*yield*/, getHomeContent()];
                    case 1:
                        _a.value = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        var handleClose = function () {
            showNotification.value = false;
        };
        return function (_ctx, _cache) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var _component_el_icon = _resolveComponent("el-icon");
            var _component_router_link = _resolveComponent("router-link");
            var _component_EcosystemSwiper = _resolveComponent("EcosystemSwiper");
            var _component_EventSwiper = _resolveComponent("EventSwiper");
            var _component_el_image = _resolveComponent("el-image");
            var _component_ArrowRightBold = _resolveComponent("ArrowRightBold");
            var _component_el_footer = _resolveComponent("el-footer");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_Transition, { name: "fade" }, {
                        default: _withCtx(function () { return [
                            (showNotification.value)
                                ? (_openBlock(), _createBlock(SuccessfulPayment, {
                                    key: 0,
                                    target: String(_unref(route).query.target),
                                    onClose: handleClose
                                }, null, 8, ["target"]))
                                : _createCommentVNode("", true)
                        ]; }),
                        _: 1
                    }),
                    _createElementVNode("header", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(VariableLogo, {
                                size: 45,
                                pd: 8,
                                rounded: 10
                            }),
                            _cache[0] || (_cache[0] = _createElementVNode("p", { class: "home__header-welcome" }, "Добро пожаловать в закрытый клуб", -1))
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_el_icon, { size: 16 }, {
                                default: _withCtx(function () { return [
                                    _createElementVNode("img", {
                                        src: _unref(magnifierIcon),
                                        alt: ""
                                    }, null, 8, _hoisted_5)
                                ]; }),
                                _: 1
                            })
                        ])
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("section", { class: "home__greeting" }, [
                        _createElementVNode("p", { class: "home__greeting-subtitle" }, "Небольшая инфа о клубе, вводный текст. Масштабная и тёплая конференция для IT-специалистов. Только актуальные темы и живые кейсы — одно из главных требований к спикерам. Каждый доклад проходит строгий отбор и экспертную оценку Программного комитета. Крупнейшая площадка города с лучшим техническим оснащением: звук, свет")
                    ], -1)),
                    _createElementVNode("section", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "home__ecosystem-title home__block-title" }, " Экосистема ", -1)),
                            _createVNode(_component_router_link, {
                                class: "home__ecosystem-more home__block-more",
                                to: '/ecosystem'
                            }, {
                                default: _withCtx(function () { return _cache[1] || (_cache[1] = [
                                    _createTextVNode(" Все ")
                                ]); }),
                                _: 1
                            })
                        ]),
                        ((_a = localHomeContent.value) === null || _a === void 0 ? void 0 : _a.ecosystem)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(_component_EcosystemSwiper, {
                                    ecosystemList: (_b = localHomeContent.value) === null || _b === void 0 ? void 0 : _b.ecosystem
                                }, null, 8, ["ecosystemList"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("section", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "home__events-title home__block-title" }, " Мероприятия ", -1)),
                            _createVNode(_component_router_link, {
                                class: "home__events-more home__block-more",
                                to: '/events'
                            }, {
                                default: _withCtx(function () { return _cache[3] || (_cache[3] = [
                                    _createTextVNode(" Все ")
                                ]); }),
                                _: 1
                            })
                        ]),
                        ((_c = localHomeContent.value) === null || _c === void 0 ? void 0 : _c.events)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_EventSwiper, {
                                    events: (_d = localHomeContent.value) === null || _d === void 0 ? void 0 : _d.events
                                }, null, 8, ["events"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("section", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "home__services-title home__block-title" }, " Услуги ", -1)),
                            _createVNode(_component_router_link, {
                                class: "home__services-more home__block-more",
                                to: '/market'
                            }, {
                                default: _withCtx(function () { return _cache[5] || (_cache[5] = [
                                    _createTextVNode(" Все ")
                                ]); }),
                                _: 1
                            })
                        ]),
                        ((_e = localHomeContent.value) === null || _e === void 0 ? void 0 : _e.services)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createVNode(ServicesSwiper, {
                                    services: (_f = localHomeContent.value) === null || _f === void 0 ? void 0 : _f.services
                                }, null, 8, ["services"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("section", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "home__news-title home__block-title" }, " Новости ", -1)),
                            _createVNode(_component_router_link, {
                                class: "home__news-more home__block-more",
                                to: '/news'
                            }, {
                                default: _withCtx(function () { return _cache[7] || (_cache[7] = [
                                    _createTextVNode(" Все ")
                                ]); }),
                                _: 1
                            })
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_g = localHomeContent.value) === null || _g === void 0 ? void 0 : _g.news, function (news) {
                                var _a, _b;
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "home__news-card",
                                    key: news.id
                                }, [
                                    _createVNode(_component_el_image, {
                                        class: _normalizeClass(["home__news-card-image", news.newsType === 'Новый член клуба' ? (((_a = news.user) === null || _a === void 0 ? void 0 : _a.avatar) ? 'image-avatar' : 'image-avatar placeholder') : 'image-banner']),
                                        fit: "cover",
                                        src: news.newsType === 'Новый член клуба' ? (((_b = news.user) === null || _b === void 0 ? void 0 : _b.avatar) ? news.user.avatar : _unref(userPlaceholder)) : news.banner
                                    }, null, 8, ["class", "src"]),
                                    _createElementVNode("p", _hoisted_18, [
                                        _createTextVNode(_toDisplayString(news.newsType) + " ", 1),
                                        _createElementVNode("span", _hoisted_19, [
                                            (news.user)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(news.newsType === 'Новый член клуба' ? "\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u043B\u0441\u044F ".concat(news.user.firstname) : "\u0410\u0432\u0442\u043E\u0440:\n                  ".concat(news.user.lastname, " ").concat(news.user.firstname)), 1))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(news.description), 1))
                                        ])
                                    ]),
                                    _createVNode(_component_router_link, {
                                        to: "/news/".concat(news.id),
                                        class: "home__news-card-follow"
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(_component_el_icon, { class: "home__news-card-follow" }, {
                                                default: _withCtx(function () { return [
                                                    _createVNode(_component_ArrowRightBold)
                                                ]; }),
                                                _: 1
                                            })
                                        ]; }),
                                        _: 2
                                    }, 1032, ["to"])
                                ]));
                            }), 128))
                        ])
                    ]),
                    _createElementVNode("section", _hoisted_22, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "home__matches-header home__block-header" }, [
                            _createElementVNode("p", { class: "home__matches-title home__block-title" }, " Сообщество ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "home__matches-card-title" }, [
                                    _createTextVNode(" Поиск коллабораций "),
                                    _createElementVNode("br"),
                                    _createTextVNode(" и партнеров "),
                                    _createElementVNode("span", { class: "matches-subtitle" }, " Найдите сообщников для воплощения своих идей ")
                                ], -1)),
                                _createVNode(_component_router_link, { to: '/matching' }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_component_el_icon, null, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_ArrowRightBold)
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "home__matches-card-title" }, [
                                    _createTextVNode(" Запросы и предложения "),
                                    _createElementVNode("span", { class: "matches-subtitle" }, " Поделитесь своими идеями с сообществом ")
                                ], -1)),
                                _createVNode(_component_el_icon, null, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_component_ArrowRightBold)
                                    ]; }),
                                    _: 1
                                })
                            ])
                        ])
                    ]),
                    _createElementVNode("section", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "home__partners-title home__block-title" }, " Партнеры ", -1)),
                            _createVNode(_component_router_link, {
                                class: "home__partners-more home__block-more",
                                to: '/partners'
                            }, {
                                default: _withCtx(function () { return _cache[12] || (_cache[12] = [
                                    _createTextVNode(" Все ")
                                ]); }),
                                _: 1
                            })
                        ]),
                        ((_h = localHomeContent.value) === null || _h === void 0 ? void 0 : _h.partners)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createVNode(PartnerList, {
                                    partners: (_j = localHomeContent.value) === null || _j === void 0 ? void 0 : _j.partners
                                }, null, 8, ["partners"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("section", _hoisted_29, [
                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "home__materials-header home__block-header" }, [
                            _createElementVNode("p", { class: "home__materials-title home__block-title" }, " Информация ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_30, [
                            _createVNode(MaterialLinkCard, {
                                title: 'База знаний',
                                subtitle: 'Документы, видео, книги и многое другое',
                                link: '/materials'
                            }),
                            _createVNode(MaterialLinkCard, {
                                title: 'FAQ',
                                subtitle: 'Ответы на часто задаваемые вопросы',
                                link: '/'
                            })
                        ])
                    ])
                ]),
                ((_k = localHomeContent.value) === null || _k === void 0 ? void 0 : _k.footer)
                    ? (_openBlock(), _createBlock(_component_el_footer, {
                        key: 0,
                        class: "footer"
                    }, {
                        default: _withCtx(function () {
                            var _a, _b;
                            return [
                                _createElementVNode("div", _hoisted_31, [
                                    _cache[16] || (_cache[16] = _createElementVNode("p", { class: "footer__title" }, " Документы ", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_a = localHomeContent.value) === null || _a === void 0 ? void 0 : _a.footer.filter(function (item) { return item.itemType === 'Документ'; }), function (footerItem) {
                                        return (_openBlock(), _createElementBlock("a", {
                                            key: footerItem.id,
                                            class: "footer__item",
                                            href: footerItem.link,
                                            target: "_blank"
                                        }, _toDisplayString(footerItem.name), 9, _hoisted_32));
                                    }), 128))
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                    _cache[17] || (_cache[17] = _createElementVNode("p", { class: "footer__title" }, " Реквизиты ", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_b = localHomeContent.value) === null || _b === void 0 ? void 0 : _b.footer.filter(function (item) { return item.itemType === 'Реквизит'; }), function (footerItem) {
                                        return (_openBlock(), _createElementBlock("a", {
                                            key: footerItem.id,
                                            class: "footer__item",
                                            href: footerItem.link,
                                            target: "_blank"
                                        }, _toDisplayString(footerItem.name), 9, _hoisted_34));
                                    }), 128))
                                ])
                            ];
                        }),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
